<template>
  <div class="bk bk-pagination">
    <button :disabled="page === 0" @click="page--">
      <Icon name="arrow-left" />
    </button>
    <div>{{ page + 1 }} / {{ totalPages }}</div>
    <button :disabled="page >= totalPages - 1" @click="page++">
      <Icon name="arrow-right" />
    </button>
  </div>
</template>

<script setup>
import { Icon } from "#blokkli/components";
defineProps({
  totalPages: { type: Number, required: true }
});
const page = defineModel({ type: Number, ...{ default: 0 } });
</script>
